import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0516eb4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-tradelaboBlue text-white p-2 h-14" }
const _hoisted_2 = { class: "grid grid-cols-12" }
const _hoisted_3 = { class: "col-span-1 flex items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "col-span-2 flex items-center justify-start" }
const _hoisted_7 = { class: "col-span-5 flex items-center justify-start lg:justify-end" }
const _hoisted_8 = { class: "mr-7" }
const _hoisted_9 = { class: "col-span-4 flex items-center justify-end" }
const _hoisted_10 = { class: "mr-1" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = { class: "mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon_text = _resolveComponent("base-icon-text")!
  const _component_base_logo = _resolveComponent("base-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_search_box = _resolveComponent("search-box")!
  const _component_base_avatar = _resolveComponent("base-avatar")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layouts_auth_width, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (!_ctx.store.state.layout.sidebar.open)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_base_icon_text, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('layout/switchSidebarOpen'))),
                        class: "cursor-pointer",
                        path: _ctx.mdiMenu,
                        text: "メニュー"
                      }, null, 8, ["path"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_base_icon_text, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.dispatch('layout/switchSidebarOpen'))),
                        class: "cursor-pointer",
                        path: _ctx.mdiClose,
                        text: "閉じる"
                      }, null, 8, ["path"])
                    ]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: _ctx.homePath }, {
              default: _withCtx(() => [
                _createVNode(_component_base_logo, { class: "h-9" })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_search_box)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, { to: "/video" }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon_text, {
                    path: _ctx.mdiPlayBoxOutline,
                    text: "動画"
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, { to: "/seminar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon_text, {
                    path: _ctx.mdiCalendarCheck,
                    text: "セミナー日程"
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_link, { to: "/notice" }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon_text, {
                    path: _ctx.mdiEmailCheck,
                    text: "お知らせ"
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_router_link, { to: "/account" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_avatar)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}